import React, { useEffect, useState } from "react"
import { ReactSVG } from "react-svg"

import * as styles from "./burger-menu.module.scss"
import { HeaderFieldsFragment, DatoCmsAllLocalesForDatoCmsArticleSlug, DatoCmsSlugsConfiguration} from "../../../../../graphql-types"

import { Link } from "gatsby"
import burgerMenuIcon from "../../../../../static/vectors/burgerMenuIcon.svg"
import cross from "../../../../../static/vectors/cross.svg"
import arrow from "../../../../../static/vectors/mobileMenuArrow.svg"
import SearchModule from "../../../common/jsx/search-module/search-module"
import { useLocale } from "../../../../context/locale-context"
import { changeLanguage } from "../../../common/functions/functions"

type BurgerMenuProps = {
  data: HeaderFieldsFragment
  slugs: DatoCmsSlugsConfiguration
  searchRequestSlug: string
  contactSlug: string
  currentRoute?: string
  allSlugLocales: [DatoCmsAllLocalesForDatoCmsArticleSlug]
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ data, slugs, searchRequestSlug, contactSlug, currentRoute, allSlugLocales }) => {
  const { locale, defaultLocale } = useLocale()
  const [menuOpened, setMenuOpened] = useState(false)
  const [searchModuleOpened, setSearchModuleOpened] = useState(false)
  const isOnBrowser = typeof window !== "undefined"

  const closeMenu = () => {
    setMenuOpened(false)
  }

  if (menuOpened) {
    return (
      <div className={styles.menuContainer}>
        <div className={styles.menuContent}>
          <section className={styles.iconContainer}>
            <Link to={defaultLocale === locale ? "/" : `/${locale}`}>
              <img src={data.v2Logo.url} alt={data.v2Logo.alt || ""} />
            </Link>
            <button className={styles.crossButton} onClick={() => setMenuOpened(false)} aria-label="Close menu">
              <img src={cross} className={styles.cross} />
            </button>
          </section>
          <ul className={styles.linksContainer}>
            <hr className={styles.linkSeparator} style={{ }} />
            {data.v2Menu.map((menuLinks, index) => (
              <li key={index} style={{ width: "100%", margin: "0px" }}>
                {menuLinks.isAnchorInPage ? (
                  <button
                    onClick={() => {
                      const anchor = document.getElementById(menuLinks.anchorSection)
                      if (anchor) {
                        anchor.scrollIntoView({ behavior: "smooth" })
                        closeMenu()
                      }
                    }}
                    className={styles.linkElementAnchor}
                  >
                    {menuLinks.title}
                    <img src={arrow} className={styles.menuArrow} />
                  </button>
                ) : (
                  <Link
                  to={
                    menuLinks.isInternalPage
                      ? locale === defaultLocale
                        ? `/${menuLinks.internalLink?.slug}`
                        : `/${locale}/${menuLinks.internalLink?.slug}`
                      : menuLinks.externalLink
                  }
                  target={!menuLinks.isInternalPage && "_blank"}
                  onClick={() => closeMenu()}
                  className={styles.linkElement}
                >
                  {menuLinks.title}
                  <img src={arrow} className={styles.menuArrow} />
                  </Link>
                )}
                <hr className={styles.linkSeparator} />
              </li>
            ))}
          </ul>
          <span className={styles.langSelector}>
            <SearchModule
              searchPlaceholder={data.searchPlaceholder}
              searchRequestSlug={searchRequestSlug}
              buttonSearchAriaLabel={data.buttonSearchAriaLabel}
              isMobileSearchBar={false}
            />
            <li>
              <Link to={changeLanguage(currentRoute, slugs, allSlugLocales, "en", defaultLocale)} className={styles.lang} title="EN English version">
                <span style={{ fontWeight: locale === "en" ? "bold" : "normal" }}>EN</span>
              </Link>
            </li>
            <li>
              /
            </li>
            <li>
              <Link to={changeLanguage(currentRoute, slugs, allSlugLocales, "fr", defaultLocale)} className={styles.lang} title="FR version française">
                <span style={{ fontWeight: locale === "fr" ? "bold" : "normal" }}>FR</span>
              </Link>
            </li>
          </span>
        </div>
      </div>
    )
  } else if (searchModuleOpened) {
    return (
      <div className={styles.menuContainer}>
        <div className={styles.searchModuleContent}>
          <section className={styles.iconContainer}>
            <button className={styles.iconCircle} onClick={() => setSearchModuleOpened(false)} aria-label="Close menu">
              <ReactSVG src={cross} className={styles.icon} />
            </button>
          </section>
          <section className={styles.searchBarContainer}>
            <SearchModule
              searchPlaceholder={data.searchPlaceholder}
              buttonSearchAriaLabel={data.buttonSearchAriaLabel}
              searchRequestSlug={searchRequestSlug}
              isMobileSearchBar={true}
            />
          </section>
        </div>
      </div>
    )
  } else {
    return (
      <div className={styles.header}>
        <div className={styles.headerContent}>
        <section className={styles.logoContainer}>
            <Link className={styles.logoLink} to={locale === defaultLocale ? `/` : `/${locale}`}>
              <img src={data.v2Logo.url} alt={data.logo.alt || ""} className={styles.logo} />
            </Link>
          </section>

          <section className={styles.iconContainer}>
            <button className={styles.menuButton} onClick={() => setMenuOpened(true)} aria-label="Open menu">
              <ReactSVG src={burgerMenuIcon} className={styles.icon} />
            </button>
          </section>
        </div>
      </div>
    )
  }
}
export default BurgerMenu
